import { Box } from "@mui/material";
import React from "react";
import { useBoardName } from "../../../../reactQuery/boards";
import Loader from "../../../../components/Loader";
import OpenCardDetail from "../Kanban/openCardDetail";
import FeedItemComponent from "./FeedItemComponent";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { useFeedHistoryItems } from "./hooks/useFeedHistoryItems";

const HistoryItems = () => {
  const { id } = useBoardIdByKey();
  const { boardName } = useBoardName(id);
  const { allData, bottomRef, cardId, hasMore, isFetching, isInitialLoading } =
    useFeedHistoryItems(id);

  if (isInitialLoading) {
    return <div className="loader-center"><Loader color="black" /></div>;
  }

  return (
    <>
      {cardId && <OpenCardDetail />}
      {allData.length > 0 ? (
        <Box className="feed-outer-container">
          <Box overflow="auto" flexGrow={1}>
            {allData.map(item => (
              <FeedItemComponent
               key={item.id}
               item={item}
               boardName={boardName}
             />
            ))}
          </Box>
          {hasMore && (
            <Box ref={bottomRef} display="flex" justifyContent="center" my={2}>
              <Loader color="black" />
            </Box>
          )}
        </Box>
      ) : (
        <Box className="no-record-found-container">No Record Found</Box>
      )}
    </>
  );
};

export default React.memo(HistoryItems);
